
/// <reference path='../_all.ts' />

module shoppinglist {
  'use strict';

  export class ShoppingList {
    constructor(
      public ID: string,
      public State: number,
      public Type: number,
      public Name: string,
      public OwnerUserName: string,
      public Created: Date,
      public Changed: Date,
      public Accessed: Date,
      public Lines: ShoppingListLine[],
      public dirty : boolean) //addition to manage changes to the shoppinglist.
    {
    }
  }
}